module.exports = __webpack_public_path__ + "img/page4-5.1a832c7d.png";